import { gql, useMutation } from "@apollo/client";
import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ResourceComponentProps,
  Filter,
  DateField,
  ReferenceField,
  ReferenceInput,
  AutocompleteInput,
  FunctionField,
  Button,
  useNotify,
} from "react-admin";
import { printOvertimeRule } from "../../helpers/print-overtime-rule";
import { printUser } from "../../helpers/print-user";

export const AlayaCareEmployeeList = (props: ResourceComponentProps) => (
  <List
    {...props}
    bulkActionButtons={<AlayaCareEmployeeListActions />}
    title="AlayaCare Employees"
    filters={
      <Filter {...props}>
        <ReferenceInput
          label="AlayaCareEnvironment"
          reference="AlayaCareEnvironment"
          source="alayaCareEnvironmentId"
        >
          <AutocompleteInput optionText="baseApiUrl" />
        </ReferenceInput>
        <ReferenceInput
          label="Linked Agent User"
          reference="User"
          source="userId"
          filterToQuery={(q: string) => ({ q })}
        >
          <AutocompleteInput optionText={printUser} />
        </ReferenceInput>
      </Filter>
    }
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField
        sortable={false}
        label="AlayaCareEnvironment"
        reference="AlayaCareEnvironment"
        source="alayaCareEnvironment.id"
      >
        <TextField source="baseApiUrl" />
      </ReferenceField>
      <ReferenceField
        sortable={false}
        label="User"
        reference="User"
        source="user.id"
      >
        <FunctionField render={printUser} />
      </ReferenceField>
      <TextField source="alayaCareEmployeeId" label="AlayaCare employee id" />
      <TextField
        source="alayaCareEmployeeExternalId"
        label="AlayaCare employee external id"
      />
      <ReferenceField
        sortable={false}
        label="Overtime Rule"
        reference="AlayaCareOvertimeRule"
        source="overtimeRule.id"
      >
        <FunctionField render={printOvertimeRule} />
      </ReferenceField>
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </Datagrid>
  </List>
);

const AlayaCareEmployeeListActions = ({ selectedIds }: any) => {
  const notify = useNotify();
  const [syncEmployeeVisits, { loading: syncingEmployeeVisits }] = useMutation(
    gql`
      mutation syncAlayaCareEmployeesVisits($ids: [ID!]!) {
        syncAlayaCareEmployeeVisits(ids: $ids)
      }
    `
  );

  return (
    <>
      <Button
        label="Sync AlayaCare visits"
        disabled={syncingEmployeeVisits}
        variant="outlined"
        onClick={async () => {
          try {
            await syncEmployeeVisits({ variables: { ids: selectedIds } });
            notify("Queued AlayaCare visit sync for employees");
          } catch (error) {
            console.error(error);
            notify("An error occurred syncing employee visits", "error");
          }
        }}
      />
    </>
  );
};
